export var MediaTextLayout;
(function (MediaTextLayout) {
  MediaTextLayout["MediaLeft"] = "media-left";
  MediaTextLayout["MediaRight"] = "media-right";
})(MediaTextLayout || (MediaTextLayout = {}));